module.exports = __webpack_public_path__ + "img/Integrity.3dc98a3e.gif";